/**
 * Query Helpers for Scheduled Meetings Context
 *
 * Contains helper functions specific to scheduled meetings queries
 * that don't need to be exposed globally.
 */

import type { ScheduledMeetingsQuery } from '../types';

/**
 * Generate query keys for TanStack Query
 * Ensures consistent cache keys across the application
 */
export const SCHEDULED_MEETINGS_QUERY_KEYS = {
  all: ['scheduled-meetings'] as const,
  lists: () => [...SCHEDULED_MEETINGS_QUERY_KEYS.all, 'list'] as const,
  list: (query?: ScheduledMeetingsQuery) =>
    [...SCHEDULED_MEETINGS_QUERY_KEYS.lists(), query] as const,
  details: () => [...SCHEDULED_MEETINGS_QUERY_KEYS.all, 'detail'] as const,
  detail: (room: string) => [...SCHEDULED_MEETINGS_QUERY_KEYS.details(), room] as const,
  flat: (query?: ScheduledMeetingsQuery) =>
    [...SCHEDULED_MEETINGS_QUERY_KEYS.all, 'flat', query] as const,
};
